
import Vue from "vue";
import UIFeatureMixinVue from "@/mixins/UIFeatureMixin.vue";
import AppPropsMixin from "@/mixins/AppPropsMixin.vue";

export default Vue.extend({
  name: "Contacts",
  props: {
    contactList: { type: Array, default: () => [] },
    countyCode: { type: String, default: "" },
  },
  mixins: [UIFeatureMixinVue, AppPropsMixin],
});
